import { Card, CardContent, LoadingState, PageHeader } from '@sitewise/ui';
import { useQuery } from '@tanstack/react-query';
import { Building2, Users } from 'lucide-react';
import { Link } from 'react-router-dom';


import { listOrgs } from '../../api/admin.js';

export function AdminDashboardPage() {
  const orgsQuery = useQuery({ queryKey: ['admin-orgs'], queryFn: listOrgs });

  return (
    <>
      <PageHeader
        title="Platform overview"
        description="Aggregate health of every tenant on SiteWise. Use ⌘K from any org subdomain to jump deeper."
      />

      {orgsQuery.isPending ? (
        <LoadingState rows={3} />
      ) : (
        <div className="grid gap-4 sm:grid-cols-3">
          <Card>
            <CardContent className="p-4">
              <div className="flex items-center justify-between">
                <span className="text-xs font-medium uppercase tracking-wide text-fg-muted">
                  Organizations
                </span>
                <Building2 className="h-4 w-4 text-fg-muted" />
              </div>
              <p className="mt-3 text-3xl font-semibold tabular-nums">
                {orgsQuery.data?.orgs.length ?? 0}
              </p>
              <Link
                to="/admin/orgs"
                className="mt-1 block text-xs font-medium text-admin-accent hover:underline"
              >
                Manage organizations →
              </Link>
            </CardContent>
          </Card>
          <Card>
            <CardContent className="p-4">
              <div className="flex items-center justify-between">
                <span className="text-xs font-medium uppercase tracking-wide text-fg-muted">
                  Total users
                </span>
                <Users className="h-4 w-4 text-fg-muted" />
              </div>
              <p className="mt-3 text-3xl font-semibold tabular-nums">
                {orgsQuery.data?.orgs.reduce((acc, o) => acc + (o.userCount ?? 0), 0) ?? 0}
              </p>
              <p className="mt-1 text-xs text-fg-muted">Across all tenants</p>
            </CardContent>
          </Card>
          <Card>
            <CardContent className="p-4">
              <div className="flex items-center justify-between">
                <span className="text-xs font-medium uppercase tracking-wide text-fg-muted">
                  Audit log
                </span>
              </div>
              <Link
                to="/admin/audit"
                className="mt-3 block text-3xl font-semibold tabular-nums text-admin-accent hover:underline"
              >
                Review →
              </Link>
              <p className="mt-1 text-xs text-fg-muted">All super-admin and tenant events</p>
            </CardContent>
          </Card>
        </div>
      )}
    </>
  );
}
